export const ICRTNProductTypes: string[] = ['CBP1', 'CBP3', 'CP10', 'HSP'];